import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

const HOME_API = environment.APIEndpoint + '/api/home';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  constructor(private http: HttpClient) { }

  getAllFormulas(): Observable<any> {
    return this.http.get(HOME_API + "/formulas", httpOptions);
  }

  initStudent(studentRequest: any): Observable<any> {
    return this.http.post(HOME_API + "/initStudent", studentRequest, httpOptions);
  }

}
